/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_Q1Inputs */

const en_guide_what_is_json_faq_q1 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is JSON the same as JavaScript?`)
};

const ko_guide_what_is_json_faq_q1 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON과 JavaScript는 같은 건가요?`)
};

const ja_guide_what_is_json_faq_q1 = /** @type {(inputs: Guide_What_Is_Json_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONはJavaScriptと同じですか？`)
};

/**
* | output |
* | --- |
* | "Is JSON the same as JavaScript?" |
*
* @param {Guide_What_Is_Json_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_q1 = /** @type {((inputs?: Guide_What_Is_Json_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_q1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_q1(inputs)
	return ja_guide_what_is_json_faq_q1(inputs)
});